//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonFooter from '@/components/CommonFooter.vue';
import CustomMap from '@/components/CustomMap.vue';
import CustomSwiper from '@/components/CustomSwiper.vue';
import VideoWrapper from '@/components/VideoWrapper.vue';
import NavBar from '@/components/NavBar.vue';
import QuickPoint from '@/components/QuickPoint.vue';
import CustomDialog from '@/components/CustomDialog.vue';
import ScrollTop from '@/components/ScrollTop.vue';

export default {
    components: {
        CommonFooter,
        CustomMap,
        CustomSwiper,
        VideoWrapper,
        NavBar,
        QuickPoint,
        CustomDialog,
        ScrollTop
    },
    data() {
        return {
            swiperList: [],
            show: {
                vr: false
            },
            viewIntro: '',
            guideList: [],
            vrData: '',
            cultureList: []
        };
    },
    watch: {
        i18n() {
            this.getGuideList();
        }
    },
    mounted() {
        new window.Swiper('.swiper', {
            // 循环模式选项
            loop: false,
            /* autoplay: {
                disableOnInteraction: false
            }, */
            effect: 'coverflow',
            slidesPerView: 'auto',
            centeredSlides: false,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 0,
                modifier: 0,
                slideShadows: false
            },
            // 如果需要前进后退按钮
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
        this.getViewIntro();
        this.getGuideList();
        this.getVr();
        this.getCulture();
    },
    methods: {
        getViewIntro() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: '7'
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.viewIntro = res.data;
                }
            });
        },
        getGuideList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '8',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.guideList = res.data.data;
                }
            });
        },
        getVr() {
            this.axios({
                method: 'post',
                url: '/articleCategory/detail',
                data: {
                    id: 60
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.vrData = res.data;
                }
            });
        },
        getCulture() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 6
                }
            }).then((res) => {
                if (res.code === 0) {
                    this.cultureList = res.data;
                }
            });
        }
    }
};
